module.exports = __webpack_public_path__ + "img/banner-mobile.0c9376f3.png";